import React from 'react';
import classNames from 'classnames';
import { useLanguage } from '../../context/LanguageProvider/LanguageProvider';

export default function ExpertiseTechTags({ keywordKeys, className }) {
  const { t } = useLanguage();

  if (!keywordKeys?.length) return null;

  return (
    <div className={classNames('jassp-expertise-tech-tags', className)}>
      <p className="jassp-expertise-tech-tags-label small text-muted text-uppercase fw-semibold mb-2">
        {t('expertises.tech.label')}
      </p>
      <ul className="nk-tag flex-wrap gap-2 mb-0">
        {keywordKeys.map((key) => (
          <li key={key}>
            <span className="nk-tag-item">{t(key)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
